/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiResultOfListOfobject
 */
export interface ApiResultOfListOfobject {
    /**
     * 
     * @type {Array<object>}
     * @memberof ApiResultOfListOfobject
     */
    data?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfobject
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfobject
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfobject
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfobject
     */
    result?: ApiResultOfListOfobjectResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfobjectResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfobjectFromJSON(json: any): ApiResultOfListOfobject {
    return ApiResultOfListOfobjectFromJSONTyped(json, false);
}

export function ApiResultOfListOfobjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfobject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfobjectToJSON(value?: ApiResultOfListOfobject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

